export const UPDATE_GROUP = 'UPDATE_GROUP'